<template>
  <div id="banner" class="max-text-width">
    <div class="content">
      <h1>{{ $t('affiliateProgram') }}</h1>
      <p class="describe max-text-width">{{ $t('memberInfo') }}</p>
      <slot></slot>
    </div>
    <img src="/static/img/affiliate/banner_img.png" alt="">
  </div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'affiliate-banner',
    locales
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/mixins/button";
  @import "../../../assets/scss/formstyle";
  @import "../../../assets/scss/mixins/gradient";

  $max-text-width: 11.8rem;

  * {
    margin: 0;
    padding: 0;
  }

  .max-text-width {
    max-width: $max-text-width;
    margin: 0 auto;
  }

  #banner {
    padding-top: 210px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content, img {
      width: 48%;
    }
    h1 {
      font-size: .58rem;
      color: #111111;
      line-height: 68px;
      font-weight: 700;
      margin-bottom: 24px;
    }
    p.describe {
      font-size: 24px;
      color: #111111;
      letter-spacing: 1px;
      line-height: 36px;
      margin-bottom: .4rem;
    }
  }

  @media (max-width: 911px) {
    #banner {
      padding-top: 40px;
      display: block;
      .content {
        width: 100%;
        margin-bottom: 44px;
      }
      h1 {
        text-align: center;
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 16px;
      }
      p.describe {
        font-size: 14px;
        letter-spacing: 0.58px;
        text-align: center;
        line-height: 20px;
      }
      img {
        width: 70%;
        display: block;
        margin: 0 auto;
      }
    }
  }

  @media (max-width: 767px) {
    #banner img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// Banner.vue?20dfa970